<template>
  <div
    class="video-wrapper"
    :class="{ 'vodalys' : isVodalys }"
  >
    <iframe
      v-if="isVodalys && typePlayer == 'vodalys'"
      class="vodalys"
      width="1280"
      height="720"
      :src="`https://console.vodalys.studio/p/${this.videoIframe}/#?embedded=true`"
      allowfullscreen="1"
      frameborder="0"
      scrolling="no"
    />

    <video-player
      :options="videoOptions"
      v-if="isVodalys && typePlayer == 'm3u'"
    />

    <iframe
      v-if="typePlayer == 'iframe'"
      class="tototottototot"
      width="1280"
      height="720"
      :src="videoIframe"
      allowfullscreen="1"
      frameborder="0"
      scrolling="no"
    />

    <youtube
      v-if="!isVodalys && typePlayer === 'youtube'"
      :video-id="this.videoIframe"
      ref="youtube"
    />
  </div>
</template>
<script>
import axios from 'axios';
import { Youtube } from 'vue-youtube';
import VideoPlayer from './VideoPlayer.vue';

export default {
  components: {
    Youtube,
    VideoPlayer,
  },
  props: {
    source: {
      type: Array,
      required: true,
    },
    typePlayer: {
      type: String,
      required: true,
    },
    displayVodalys: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      video: '',
      isVodalys: true,
      isVodalysType: false,
      videoIframe: '',
      videoOptions: {
        autoplay: true,
        controls: true,
        sources: [
          {
            src:
              this.source[2],
          },
        ],
      },
    }
  },

  beforeMount() {
    this.updateIsVodalys();
  },

  methods: {
    updateIsVodalys() {
      const newAjaxUrl = `${this.displayVodalys}`;
      try {
        axios.get(newAjaxUrl).then((response) => this.assignVar(response));
      } catch (error) {
        console.log(error)
      }
    },
    assignVar(response) {
      this.isVodalys = response.data.data.filtered;


      this.video = this.isVodalys ? this.source[0] : this.source[1];
      // eslint-disable-next-line
      this.videoIframe = this.typePlayer == 'iframe' ? this.source[3] : this.video;

      // this.video = this.isVodalys ? this.source[0] : this.source[1];
    },
  },
}
</script>
